// extracted by mini-css-extract-plugin
export default {"column":"column__column-aAARN"};